<template>
  <div class="side-menu left" v-if="width > tabSize">
    <vue-custom-scrollbar
      id="scroll-area"
      class="scroll-area"
      :settings="settings"
    >
      <sidebar-content />
    </vue-custom-scrollbar>
  </div>
  <b-sidebar
    v-else
    id="drawer"
    right
    backdrop
    no-header-close
    @hidden="hideDrawer"
    width="250px"
  >
    <vue-custom-scrollbar
      id="scroll-area"
      class="scroll-area"
      :settings="settings"
    >
      <sidebar-content />
    </vue-custom-scrollbar>
  </b-sidebar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { mapActions, mapState } from "vuex";
import {
  TAB_SIZE,
  TOGGLE_SIDEBAR,
  UPDATE_WINDOW_WIDTH
} from "@/store/mutation-types";
import SidebarContent from "./SidebarContent.vue";
export default {
  name: "Sidebar",
  components: {
    SidebarContent,
    vueCustomScrollbar
  },
  computed: {
    ...mapState("setting", ["width", "open"])
  },
  created() {
    window.addEventListener("resize", () => {
      this[UPDATE_WINDOW_WIDTH](window.innerWidth);
    });
  },
  data() {
    return {
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      tabSize: TAB_SIZE
    };
  },
  methods: {
    ...mapActions("setting", [TOGGLE_SIDEBAR, UPDATE_WINDOW_WIDTH]),
    hideDrawer: function() {
      this[TOGGLE_SIDEBAR](true);
    }
  }
};
</script>

<style lang="scss">
.side-menu {
  bottom: 0;
  top: 0;
  width: 240px;
  z-index: 2;

  &.left {
    background: #ffffff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 68px;

    body.fixed-left & {
      bottom: 50px;
      height: 100%;
      margin-bottom: -70px;
      margin-top: 0;
      padding-bottom: 70px;
      position: fixed;
    }
  }
}

#wrapper.enlarged {
  .side-menu {
    width: 70px;
    z-index: 5;
  }
}
</style>
